import api from "./Api";

class AdicionalService {
  GetAdicional(payload) {
    return api.get("/v1/adicional/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAdicional(payload) {
    return api.post("/v1/adicional/", payload).then((response) => {
      return response.data;
    });
  }

  PutAdicional(payload) {
    return api.put("/v1/adicional/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAdicional(payload) {
    return api.delete("/v1/adicional/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAdicionalOData(payload) {
    return api.get("/OData/Adicional" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AdicionalService();
